import React, { useState } from "react";
import shortid from "shortid";
import { withRouter } from "react-router-dom";
import VendorCaseStudyLocked from "./VendorCaseStudyLocked";
import VendorCaseStudyUnLocked from "../CaseStudyPremium/VendorCaseStudy";
import Loader from "../../../Common/Loader/";
import ClaimProfile from "../../../Common/Popups/ClaimProfile";

const VendorCaseStudiesLocked = (props) => {
  const [isUpgrade, setUpgrade] = useState(false);

  const reveiewToRender = (reviews, itemOnPage) => {
    let tempReview = [...reviews];
    tempReview.splice(0, 3);
    if (itemOnPage === 15) {
      if (!Boolean(tempReview.length % 2)) {
        //even
        return tempReview;
      } else {
        //odd
        if (tempReview.length >= props.itemOnPage - 2) {
          tempReview.splice(0, 1);
        }
        return tempReview;
      }
    } else if (itemOnPage === 30) {
      if (!Boolean(tempReview.length % 2)) {
        //even
        if (tempReview.length >= props.itemOnPage - 2) {
          tempReview.splice(0, 1);
        }
        return tempReview;
      } else {
        //odd

        return tempReview;
      }
    } else {
      //case of all
      return tempReview;
    }
  };

  const setClaimProfilePopUpFalse = () => {
    setUpgrade(false);
  };

  return (
    <React.Fragment>
      {props.vendorCaseStudies?.reviews?.length > 0 ? (
        <ul>
          {!!props.itemOnPage &&
            reveiewToRender(
              props.vendorCaseStudies?.reviews,
              props.itemOnPage
            ).map((review, index) => {
              if (props.vendorCaseStudies?.num_unblurred_reviews === -1) {
                return (
                  <VendorCaseStudyUnLocked
                    key={shortid.generate()}
                    {...review}
                    index={index + 1}
                    linkedInUrl={props.vendorCaseStudies?.linkedin_signin_url}
                    addClass={true}
                    pathname={props.location.pathname}
                    isLeadGenPopUp={props.vendorProfile?.is_lead_generate_popup}
                    totalRefCount={
                      props.vendorCommon?.casestudy_count
                        ? props.vendorCommon?.casestudy_count +
                          props.vendorCommon?.testimonial_count +
                          props.vendorCommon?.video_count
                        : 0
                    }
                    companyId={
                      props.vendorCommon?.company_id
                        ? props.vendorCommon?.company_id
                        : -1
                    }
                  />
                );
              } else {
                return (
                  <VendorCaseStudyLocked
                    key={shortid.generate()}
                    {...review}
                    linkedInUrl={props.vendorCaseStudies?.linkedin_signin_url}
                    vendorname={props.vendorCommon.name}
                    reviewCount={props.vendorCaseStudies?.total_reviews_count}
                    setUpgrade={setUpgrade}
                    pathname={props.location.pathname}
                    isLeadGenPopUp={props.vendorProfile?.is_lead_generate_popup}
                    totalRefCount={
                      props.vendorCommon?.casestudy_count
                        ? props.vendorCommon?.casestudy_count +
                          props.vendorCommon?.testimonial_count +
                          props.vendorCommon?.video_count
                        : 0
                    }
                    companyId={
                      props.vendorCommon?.company_id
                        ? props.vendorCommon?.company_id
                        : -1
                    }
                    vendorProfile={props.vendorProfile}
                  />
                );
              }
            })}
        </ul>
      ) : (
        <Loader />
      )}
      {isUpgrade ? (
        <ClaimProfile setClaimProfilePopUpFalse={setClaimProfilePopUpFalse} />
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default withRouter(VendorCaseStudiesLocked);
